import React from 'react';
import { log } from 'log';

import { Button } from '@interlayer/js/components/common/Button';

import { useTranslations } from '@core/js/hooks/i18n';

import { useRunAtp } from './hooks/useRunAtp';
import { TAtpButtonConfigProps, TAtpButtonProps } from './types';

export const AtpButtonBare: React.FC<TAtpButtonProps> = ({ type, name, schedule, text }) => {
    const t = useTranslations('playtech.mobile.system.AtpButton.');
    const handleClick = useRunAtp({ schedule, type, name });

    if (!type || !name || !schedule) {
        log('error', 'Bad configuration');

        return null;
    }

    return (
        <Button onClick={handleClick}>
            {text || t('button.text')}
        </Button>
    );
};

export const AtpButton: React.FC<TAtpButtonConfigProps> = ({ config }) => {
    return <AtpButtonBare {...config} />;
};

export default AtpButton;

